export default __webpack_public_path__ + "static/media/available-amazon.f95b1cf1.svg";